(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches) return;

  const root = document.documentElement;
  const hero = document.querySelector('.home-rose-shell, .deodorant-hero-shell');
  if (!hero) return;

  const revealGroups = [
    ['.deodorant-benefits > div', 90],
    ['.home-section-head > div, .home-section-head > p', 110],
    ['.home-product-card', 110],
    ['.home-carousel-footer', 0],
    ['.brand-story-copy > .section-kicker, .brand-story-copy > h2, .brand-story-copy > p, .brand-story-reasons > div, .brand-story-copy > .text-cta', 65],
    ['.brand-press-heading', 0],
    ['.oil-feature-copy > .section-kicker, .oil-feature-copy > h2, .oil-feature-copy > p, .oil-feature-actions', 95],
    ['.families-heading > *, .family-card', 65],
    ['.diagnostic-copy > .section-kicker, .diagnostic-copy > h2, .diagnostic-copy > p, .diagnostic-copy > a, .diagnostic-note', 75]
  ];
  const revealTargets = [];
  const mediaTargets = [];
  const fold = window.innerHeight * .88;

  revealGroups.forEach(([selector, stagger]) => {
    document.querySelectorAll(selector).forEach((element, index) => {
      const rect = element.getBoundingClientRect();
      if (rect.top <= fold) return;
      element.classList.add('motion-reveal');
      element.style.setProperty('--motion-delay', `${Math.min(index * stagger, 360)}ms`);
      revealTargets.push(element);
    });
  });

  document.querySelectorAll('.brand-story-image, .oil-feature-image').forEach(element => {
    if (element.getBoundingClientRect().top <= fold) return;
    element.classList.add('motion-media');
    mediaTargets.push(element);
  });

  root.classList.add('motion-enabled');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    }, {rootMargin: '0px 0px -8% 0px', threshold: .01});
    [...revealTargets, ...mediaTargets].forEach(element => observer.observe(element));
    reducedMotion.addEventListener('change', event => {
      if (!event.matches) return;
      observer.disconnect();
      root.classList.remove('motion-enabled');
    }, {once: true});
  } else {
    [...revealTargets, ...mediaTargets].forEach(element => element.classList.add('is-visible'));
  }

  let framePending = false;
  function updateHeroMotion() {
    framePending = false;
    if (reducedMotion.matches) return;
    const rect = hero.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > window.innerHeight) return;
    const progress = Math.max(0, Math.min(1, -rect.top / (rect.height * .95)));
    const compact = window.innerWidth <= 700;
    hero.style.setProperty('--hero-photo-scale', (1 + progress * (compact ? .025 : .058)).toFixed(3));
    hero.style.setProperty('--hero-pack-shift', `${(-progress * (compact ? 12 : 34)).toFixed(1)}px`);
  }
  function requestHeroMotion() {
    if (framePending) return;
    framePending = true;
    requestAnimationFrame(updateHeroMotion);
  }
  window.addEventListener('scroll', requestHeroMotion, {passive: true});
  window.addEventListener('resize', requestHeroMotion, {passive: true});
  requestHeroMotion();
})();
